import BaseModel from '@core/model';

export class CorporateAction extends BaseModel {
    static entity = 'corporateActions';

    static fields() {
        return {
            id: this.attr(null)
        };
    }
}

export default CorporateAction;
